import React, { useContext, useRef, useState } from "react";
import { TagsContext } from "../../../../contexts/TagsContext";
import "./index.css";
import { AtendimentoContext } from "../../../../contexts/AtendimentoContext";
import caAPI from "../../../../services/caAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Form, Spinner } from "react-bootstrap";
import {useForm} from "react-hook-form"; 
import { errorToast } from "../../../../components/DommusToast";
import { usePromiseTracker } from "react-promise-tracker";
import { DommusDroppable } from "../../../../components/DommusDroppable";

export function MarcadoresLista(){
  const {tagsLista, setTagsLista} = useContext(TagsContext);
  const {marcadoresSelecionados, setMarcadoresSelecionados, totaisMarcadores, handleExecutaPesquisaTelaPrincipal, buscandoAtendimentos} = useContext(AtendimentoContext);
  const methods = useForm()
  const [openCadastroMarcador, setOpenCadastroMarcador] = useState(false);
  const {promiseInProgress: isLoadingNovoMarcador} = usePromiseTracker({area: "loading-novo-marcador"});
  const {promiseInProgress: isLoadingMarcadores} = usePromiseTracker({area: "loading-marcadores"});

  const handleSelecionarTag = (tag) => {
    if(buscandoAtendimentos){
      return;
    }
    var marcadores = marcadoresSelecionados;
    if(marcadores.includes(Number(tag?.id_tag))){
      marcadores = marcadores.filter((item) => Number(item) !== Number(tag?.id_tag))
    }else{
      marcadores = [...marcadores, Number(tag?.id_tag)]
    }

    if(!tag){
      marcadores = [];
    }

    const filtros = JSON.parse(caAPI.getLocalState('filtros'));
    if(marcadores?.length){
      filtros.tag_atendimento = tagsLista.filter((item) => marcadores.includes(Number(item?.id_tag))).map((item)=> {return {label:item.nome, value: item?.id_tag}});
    }else{
      delete filtros.tag_atendimento;
    }

    handleExecutaPesquisaTelaPrincipal(filtros);
    setMarcadoresSelecionados(marcadores);
  }

  const handleOnSubmit = (data) => {
    handleCloseCadastroMarcador(false);
    caAPI.tags.create(data.marcador).then((response)=>{
      setTagsLista((current) => [...current, response.data].sort((a,b) => a.nome > b.nome ? 1 : -1))
      handleOpenAddMarcador(true);
    }).catch((error)=>{
      errorToast.fire({
          text: "Houve um erro ao buscar os templates.",
      });
    })
  }

  const handleCloseCadastroMarcador = ()=>{
    setOpenCadastroMarcador(false);
    methods.reset();
  }

  const handleOpenAddMarcador = ()=>{
    setOpenCadastroMarcador(true);
    setTimeout(()=>{
      methods.setFocus('marcador');
    },100)
  }

  return (
    <fieldset className="marcadores-filtro-section">
      <legend>Marcadores</legend>
      {isLoadingMarcadores ?
        <div className="lista-marcadores-skeleton">
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
          <div className="item-marcador-skeleton skeleton-animation"></div>
        </div>
      :
      <>
        <div 
          className="btn-add-marcador"
          onClick={()=>{
            if(!openCadastroMarcador){
              handleOpenAddMarcador();
            }else{
              handleCloseCadastroMarcador();
            }
          }}
        >
          <FontAwesomeIcon icon={openCadastroMarcador ? faTimes : faPlus}/>
        </div>
        {isLoadingNovoMarcador ? 
          <div className="loading-novo-marcador"><Spinner animation="border" size="sm" /> Carregando</div>
        :
          openCadastroMarcador ? 
            <Form className="form-novo-marcador" onSubmit={methods.handleSubmit(handleOnSubmit)}>
              <Form.Control 
                type="text" 
                placeholder="Novo Marcador" 
                name="marcador"
                {...methods.register('marcador')}
                onKeyDown={(event)=>{
                  if(event.key === 'Escape'){
                    handleCloseCadastroMarcador();
                  }
                }}
              />
              <div className="btns-acao-novo-marcador">
                <button type="submit" className="btn-salvar"><FontAwesomeIcon icon={faCheck}/></button>
                <button type="button" className="btn-cancelar" onClick={()=>handleCloseCadastroMarcador()}><FontAwesomeIcon icon={faTimes}/></button>
              </div>
            </Form> : <></>
        }
        <div className={`lista-tags-section ${buscandoAtendimentos ? "filtro-bloqueado" : ""}`}>
          <div 
            className={`item-marcador ${!marcadoresSelecionados?.length ? "selecionado" : ""}`} 
            onClick={()=>{
              handleSelecionarTag()
            }}
          >
            Todos
            <span className="item-total">{totaisMarcadores?.total ?? 0}</span>
          </div>
          {tagsLista.map((item, index)=>{
            return(
                <DommusDroppable key={index} id={`marcador-${item?.id_tag}`}>
                  <div 
                    key={index} 
                    className={`item-marcador ${marcadoresSelecionados.includes(item.id_tag) ? "selecionado" : ""}`} 
                    onClick={()=>{
                      handleSelecionarTag(item)
                    }}
                  >
                    {!!item?.nome?.length? item?.nome : "---"} 
                    <span className="item-total">{totaisMarcadores[item?.id_tag] ?? 0}</span>
                  </div>
                </DommusDroppable>
            )
          })}
        </div>
      </>
      }
    </fieldset>
  )
}
